<!-- section template -->
<template>
  <div>
    <ValidationObserver v-slot="{ invalid, handleSubmit }">
      <el-form ref="form" :model="FormMixSubmitData" label-position="top" class="isStyleBase" :class="$style.formReservationJtails" @submit.prevent.native="handleSubmit(onSubmit)">
        <div class="row">
          <div
            :class="{
              'col-xl-9': $globalIsJtails,
              'col-12': $globalIsDingBeauty,
            }"
          >
            <div class="row">
              <div :class="$globalIsDingBeauty ? 'col-md' : 'col-md-3'">
                <ValidationProvider v-slot="{ errors }" name="分店" rules="require">
                  <el-form-item :error="errors[0]" prop="storeAlias" label="分店">
                    <el-select v-model="FormMixSubmitData.storeAlias" placeholder="無分店" :class="{ 'isStyleDingBeauty isUnderLine': $globalIsDingBeauty }" :disabled="!isSiteEnabled">
                      <el-option v-for="(option, $index) in storeOptions" :key="`storeOptions-${$index}`" :label="option.text" :value="option.value"> </el-option>
                    </el-select>
                  </el-form-item>
                </ValidationProvider>
              </div>
              <div :class="$globalIsDingBeauty ? 'col-md' : 'col-md-3'">
                <ValidationProvider v-slot="{ errors }" name="預約日期" rules="require">
                  <el-form-item :error="isIncludDisabledDayList ? '該日期非營業時間，請選擇其他日期' : errors[0]" prop="date">
                    <div slot="label">
                      <span>預約日期</span>
                      <span v-if="isCurrentDiabeldDate || isIncludDisabledDayList" class="text-danger fs-2sm">(此日期無法預約)</span>
                    </div>
                    <el-date-picker
                      ref="date"
                      v-model="FormMixSubmitData.date"
                      type="date"
                      :class="{ 'isStyleDingBeauty isUnderLine': $globalIsDingBeauty }"
                      :editable="false"
                      :clearable="false"
                      :prefix-icon="'none'"
                      :format="`[${formatDate(FormMixSubmitData.date, 'dateWeekDay')}]`"
                      :picker-options="pickerOptions"
                      value-format="yyyy-MM-dd"
                      placeholder="預約日期"
                      :popper-class="$globalIsDingBeauty ? 'isStyleSquare' : ''"
                      :disabled="!isSiteEnabled"
                      @focus="onFocus"
                    >
                    </el-date-picker>
                  </el-form-item>
                </ValidationProvider>
              </div>
              <div v-if="$globalIsDingBeauty && currentMerchant.cosmeticSetting.canSpecifyScheduleItem" :class="$globalIsDingBeauty ? 'col-md' : 'col-md-6'">
                <ValidationProvider v-slot="{ errors }" name="美容師">
                  <el-form-item :error="errors[0]" prop="date" label="指定美容師">
                    <el-select
                      v-model="FormMixSubmitData.scheduleItemId"
                      :class="{ 'isStyleDingBeauty isUnderLine': $globalIsDingBeauty }"
                      :placeholder="scheduleItemIdOptions[0] ? '選擇美容師' : '無美容師可指定'"
                      :disabled="!isSiteEnabled || !scheduleItemIdOptions[0]"
                    >
                      <el-option v-for="(option, $index) in scheduleItemIdOptions" :key="`storeOptions-${$index}`" :label="option.name" :value="option.id"> </el-option>
                    </el-select>
                  </el-form-item>
                </ValidationProvider>
              </div>
              <div v-if="$globalCategoryVisible || !!FormMixSubmitData.isUserMemberPet" class="col-md">
                <div class="row">
                  <template v-if="!!FormMixSubmitData.isUserMemberPet">
                    <div class="col-md-12">
                      <template v-if="!!currentMemberPetList && !!currentMemberPetList[0]">
                        <template v-if="$globalIsDingBeauty">
                          <ValidationProvider v-slot="{ errors }" name="使用人" rules="require">
                            <el-form-item :error="errors[0]" prop="petId" label="使用人">
                              <el-select
                                v-model="FormMixSubmitData.petId"
                                placeholder="請選擇使用人"
                                :class="{ 'isStyleDingBeauty isUnderLine': $globalIsDingBeauty }"
                                popper-class="isStylePet isStyleDingBeauty"
                                :disabled="!isSiteEnabled"
                              >
                                <el-option v-for="(option, $index) in memberPetOptions" :key="`memberPetOptions-${$index}`" :label="option.text" :value="option.value">
                                  <div class="option__item">
                                    <span class="option__content">
                                      <span class="option__text">{{ option.text }}</span>
                                    </span>
                                  </div>
                                </el-option>
                                <el-option label="新增使用人" value="new" class="isNew"> <i class="fal fa-plus mr-2"></i>新增使用人 </el-option>
                              </el-select>
                            </el-form-item>
                          </ValidationProvider>
                        </template>
                        <template v-else>
                          <ValidationProvider v-slot="{ errors }" name="我的寵物" rules="require">
                            <el-form-item :error="errors[0]" prop="petId" label="我的寵物">
                              <el-select v-model="FormMixSubmitData.petId" placeholder="請選擇寵物" class="isStylePetJtails" popper-class="isStylePet" :disabled="!isSiteEnabled">
                                <div slot="prefix">
                                  <span
                                    class="prefix__img"
                                    :style="{ backgroundImage: `url('${memberPetItem.avatar || require(`@assets/images/${$globalProjectName}/reservation/pet-avatar-default@2x.png`)}')` }"
                                  ></span>
                                  <span class="prefix__category">
                                    {{ memberPetItem.categoryTitle }} |
                                    {{ memberPetItem.sizeTitle }}
                                  </span>
                                </div>
                                <el-option v-for="(option, $index) in memberPetOptions" :key="`memberPetOptions-${$index}`" :label="option.text" :value="option.value">
                                  <div class="option__item">
                                    <span
                                      class="option__img"
                                      :style="{ backgroundImage: `url('${option.avatar || require(`@assets/images/${$globalProjectName}/reservation/pet-avatar-default@2x.png`)}')` }"
                                    ></span>
                                    <span class="option__content">
                                      <span class="option__text">{{ option.text }}</span>
                                      <span class="option__category">{{ option.categoryTitle }} | {{ option.sizeTitle }}</span>
                                    </span>
                                  </div>
                                </el-option>
                                <el-option label="新增寵物" value="new" class="isNew"> <i class="fal fa-plus mr-2"></i>新增寵物 </el-option>
                              </el-select>
                            </el-form-item>
                          </ValidationProvider>
                        </template>
                      </template>
                      <template v-else>
                        <span v-if="$globalIsJtails">
                          <div class="el-form-item">
                            <label v-if="type === 'home'" class="el-form-item__label">我的寵物(請先新增寵物)</label>
                            <BaseButton class="isStyleSecondary isRadius isFull" @click="openDialogPet"> <i class="fal fa-plus"></i> 新增寵物 </BaseButton>
                          </div>
                        </span>
                        <span v-if="$globalIsDingBeauty">
                          <div class="el-form-item">
                            <label v-if="type === 'home'" class="el-form-item__label">我的使用人</label>
                            <BaseButton class="isStyleSecondary isFull" :class="{ isRadius: $globalIsJtails }" @click="openDialogPet"> <i class="fal fa-plus"></i> 新增使用人 </BaseButton>
                          </div>
                        </span>
                      </template>
                    </div>
                  </template>
                  <template v-else>
                    <div v-if="currentMerchant.petCategories.length >= 1" class="col-md">
                      <ValidationProvider v-slot="{ errors }" :name="$t('site.HOME_FORM_CATEGOYR')" rules="require">
                        <el-form-item :error="errors[0]" prop="category" :label="$t('site.HOME_FORM_CATEGOYR')">
                          <el-select
                            v-model="FormMixSubmitData.category"
                            placeholder="類型"
                            :class="{ 'isStyleDingBeauty isUnderLine': $globalIsDingBeauty }"
                            :disabled="!isSiteEnabled"
                            @change="onChangeCategory"
                          >
                            <el-option v-for="(option, $index) in categoryOptions" :key="`categoryOptions-${$index}`" :label="option.text" :value="option.value"> </el-option>
                          </el-select>
                        </el-form-item>
                      </ValidationProvider>
                    </div>
                    <div v-if="currentMerchant.petCategories[0].children.length >= 1" class="col-md">
                      <ValidationProvider v-slot="{ errors }" :name="$t('site.HOME_FORM_SIZE')" rules="require">
                        <el-form-item :error="errors[0]" prop="size" :label="$t('site.HOME_FORM_SIZE')">
                          <el-select v-model="FormMixSubmitData.sizeAlias" placeholder="無體型" :class="{ 'isStyleDingBeauty isUnderLine': $globalIsDingBeauty }" :disabled="!isSiteEnabled">
                            <el-option v-for="(option, $index) in sizeOptions(FormMixSubmitData.category)" :key="`sizeOptions-${$index}`" :label="option.text" :value="option.value"> </el-option>
                          </el-select>
                        </el-form-item>
                      </ValidationProvider>
                    </div>
                  </template>
                  <div v-if="!$globalIsDingBeauty" class="col-12">
                    <ValidationProvider v-slot="{ errors }" name="選擇我的寵物" rules="">
                      <el-form-item :error="errors[0]" prop="isUserMemberPet" label="" style="margin-top: -0.5rem">
                        <el-checkbox v-model="FormMixSubmitData.isUserMemberPet" :disabled="!isSiteEnabled" @change="changeIsUserMemberPet"> 選擇我的寵物 </el-checkbox>
                      </el-form-item>
                    </ValidationProvider>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            :class="{
              'col-xl-3': $globalIsJtails,
              'col-12': $globalIsDingBeauty,
            }"
          >
            <template v-if="!isSiteEnabled">
              <BaseButton class="isStyleSecondary isRadius isFull formReservationJtails__submit" disabled> 尚未開放預約 </BaseButton>
            </template>
            <BaseButton
              v-else
              :disabled="invalid || !petIdValid || isIncludDisabledDayList || isCurrentDiabeldDate"
              :loading="loading"
              type="submit"
              class="isStylePrimary isFull formReservationJtails__submit"
              :class="{
                isRadius: $globalIsJtails,
              }"
            >
              <span v-html="buttonText"></span>
            </BaseButton>
            <BaseButton
              v-if="!isLoggedIn"
              :loading="loading"
              class="isStyleSecondary isFull formReservationJtails__submit mt-0"
              :class="{
                isRadius: $globalIsJtails,
              }"
              @click="goToLogin"
            >
              快速登入
            </BaseButton>
          </div>
        </div>
      </el-form>
    </ValidationObserver>
    <BasePre>FormMixSubmitData: {{ FormMixSubmitData }}</BasePre>
  </div>
</template>

<script>
import formatDate from '@utils/format-date'
import formMixin from './mixins/form'
import addDays from 'date-fns/addDays'
import getISODay from 'date-fns/getISODay'
import parseISO from 'date-fns/parseISO'
import lastDayOfMonth from 'date-fns/lastDayOfMonth'
import isThisMonth from 'date-fns/isThisMonth'
import isThisYear from 'date-fns/isThisYear'
import _debounce from 'lodash/debounce'
import liff from '@line/liff'
import lineGetProfileAndLogin from '@utils/line-get-profile-and-login'
import { messageSuccess } from '@utils/message'
import { authComputed, merchantComputed } from '@store/helpers'
import {
  getDefaultCategoryAlias,
  getDefaultDate,
  getDefaultIsUserMemberPet,
  getDefaultPetId,
  getDefaultReservationDisabledDayList,
  getDefaultStore,
  getDefaultStoreType,
  getDefaultSizeAlias,
} from '@utils/ipetbooking-get-default'
import { categoryOptions, getMemberPetOption, memberPetOptions, sizeOptions, storeOptions } from '@utils/ipetbooking-options'

const DEFAULT_SUBMIT_DATA = {
  storeAlias: '',
  date: formatDate(new Date(), 'yyyy-MM-dd'),
  category: '',
  sizeAlias: '',
  petId: '',
  isUserMemberPet: false,
}

export default {
  name: 'FormReservation2',
  mixins: [formMixin],
  props: {
    value: {
      type: Object,
      default: () => {
        return { ...DEFAULT_SUBMIT_DATA }
      },
    },
    type: {
      type: String,
      default: 'home',
      validator(value) {
        return ['home', 'reservation'].includes(value)
      },
    },
    serviceType: {
      type: String,
      default: 'reservation',
      validator(value) {
        return ['reservation', 'daycare', 'homestay'].includes(value)
      },
    },
    buttonText: {
      type: String,
      default: `'線上預約<i class="far fa-arrow-right ml-2"></i>`,
    },
  },
  data() {
    return {
      categoryOptions: Object.freeze(categoryOptions()),
      loading: false,
      datePickerYear: '',
      datePickerMonth: '',
      startDate: '',
      endDate: '',
      currentDisabledDate: [],
      formatDisabledDateTime: [],
      isCurrentDiabeldDate: false, // 當前天數是否可預約
      observer: () => {},
    }
  },
  computed: {
    ...authComputed,
    ...merchantComputed,
    memberPetOptions,
    disabledDayList() {
      return getDefaultReservationDisabledDayList({
        storeAlias: this.FormMixSubmitData.storeAlias,
        type: 'element',
      })
    },
    isIncludDisabledDayList() {
      return this.disabledDayList.includes(getISODay(parseISO(this.FormMixSubmitData.date)).toString())
    },
    petIdValid() {
      const isUserMemberPet = this.FormMixSubmitData.isUserMemberPet
      const hasPetId = this.FormMixSubmitData.petId

      return !isUserMemberPet || (!!isUserMemberPet && !!hasPetId)
    },
    pickerOptions() {
      return {
        disabledDate: (time) => {
          const diaabledDayList = this.disabledDayList

          return time.getTime() < addDays(new Date(), -1) || this.formatDisabledDateTime.includes(time.getTime()) || diaabledDayList.includes(getISODay(time).toString())
        },
      }
    },
    memberPetItem() {
      return getMemberPetOption({
        value: this.FormMixSubmitData.petId,
        type: 'item',
      })
    },
    storeOptions() {
      return storeOptions({
        type: 'open',
        storeType: 'all',
      })
    },
    /**
     * @description 首頁預約下拉
     */
    scheduleItemIdOptions() {
      const storeItem = this.storeOptions.find((item) => {
        return item.alias === this.FormMixSubmitData.storeAlias
      })
      if (storeItem.scheduleItems[0]) {
        const normalArr = [...storeItem?.scheduleItems]
        if (this.$globalIsShowRandomScheduleItem) {
          normalArr.unshift({
            id: '',
            name: '不指定',
            title: '不指定美容師',
            avatar: require('@assets/images/jtails/reservation/person.svg'),
          })
        }
        this.FormMixSubmitData.scheduleItemId = normalArr[0].id
        return normalArr
      } else {
        return []
      }
    },
  },
  watch: {
    'FormMixSubmitData.petId'(newValue, oldValue) {
      if (newValue === 'new') {
        this.FormMixSubmitData.petId = oldValue

        this.openDialogPet()
      }
    },
    storeType(newValue, oldValue) {
      const autoSelectStore = () => {
        this.FormMixSubmitData.storeAlias = getDefaultStore('', newValue)
      }

      autoSelectStore()
    },
    'FormMixSubmitData.date': {
      immediate: true,
      handler(newValue, oldValue) {
        this.$nextTick(() => {
          this.FormMixSubmitData.date = newValue || oldValue
          // this.tryToFetchCurrentReservationCalendarDate()
        })
      },
    },
    FormMixSubmitData: {
      deep: true,
      handler(newValue, oldValue) {
        this.$nextTick(() => {
          this.watchReservationCalendar()
          this.watchCurrentReservationCalendarDate()
        })
      },
    },
    datePickerYear: {
      immediate: true,
      handler(newValue, oldValue) {
        this.$nextTick(() => {
          this.currentDatePage()
        })
      },
    },
    datePickerMonth: {
      immediate: true,
      handler(newValue, oldValue) {
        this.$nextTick(() => {
          this.currentDatePage()
        })
      },
    },
    // startDate: {
    //   immediate: true,
    //   handler(newValue, oldValue) {
    //     this.tryToFetchReservationCalendar()
    //   }
    // },
  },
  created() {
    const initFormMixSubmitData = () => {
      const { store, category, sizeAlias, date, isUserMemberPet, petId } = this.$route.query

      this.FormMixSubmitData.storeAlias = getDefaultStore(store, 'all') || DEFAULT_SUBMIT_DATA.storeAlias
      this.FormMixSubmitData.date = getDefaultDate(date) || DEFAULT_SUBMIT_DATA.date

      this.FormMixSubmitData.petId = getDefaultPetId(petId) || DEFAULT_SUBMIT_DATA.petId

      this.FormMixSubmitData.isUserMemberPet = getDefaultIsUserMemberPet(isUserMemberPet) ?? DEFAULT_SUBMIT_DATA.isUserMemberPet

      this.FormMixSubmitData.category =
        getDefaultCategoryAlias({
          queryIsUserMemberPet: this.FormMixSubmitData.isUserMemberPet,
          queryPetId: this.FormMixSubmitData.petId,
          queryCategory: category,
        }) || DEFAULT_SUBMIT_DATA.category
      this.FormMixSubmitData.sizeAlias =
        getDefaultSizeAlias({
          queryIsUserMemberPet: isUserMemberPet,
          queryPetId: petId,
          querySize: sizeAlias,
          queryCategory: category,
        }) || DEFAULT_SUBMIT_DATA.sizeAlias
    }

    const initIsCanOrderDateTime = () => {
      this.startDate = formatDate(new Date(), 'yyyy-MM-dd')
      this.endDate = formatDate(lastDayOfMonth(new Date()), 'yyyy-MM-dd')
    }
    initFormMixSubmitData()
    initIsCanOrderDateTime()
  },
  mounted() {
    if (this.serviceType === 'reservation') {
      this.$refs.date.showPicker()
      this.$refs.date.hidePicker()
      const vm = this
      const callBack = function (mutations) {
        mutations.forEach((record) => {
          const formatText = record.target.textContent.toString()

          if (formatText.includes('年') && formatText.length < 7) {
            vm.datePickerYear = formatText.split(' ')[0]
          }
          if (formatText.includes('月')) {
            vm.datePickerMonth = formatText.split(' ')[0]
          }
        })
      }
      const targetYear = document.querySelectorAll('.el-date-picker__header-label')[0]
      const targetMonth = document.querySelectorAll('.el-date-picker__header-label')[1]
      this.observer = new MutationObserver(callBack)
      this.observer.observe(targetYear, {
        childList: true,
        characterData: true,
        subtree: true,
        characterDataOldValue: true,
      })
      this.observer.observe(targetMonth, {
        childList: true,
        characterData: true,
        subtree: true,
        characterDataOldValue: true,
      })
    }
  },
  destroyed() {
    const disconnectObserver = () => {
      this.observer.disconnect()
    }
    disconnectObserver()
  },
  methods: {
    formatDate,
    sizeOptions,
    onSubmit() {
      this.loading = true

      this.$FormMixinOnSubmitSuccess()
    },
    changeIsUserMemberPet(value) {
      if (value && !this.isLoggedIn) {
        const loggedInFn = () => {
          this.$nextTick(() => {
            this.tryToFetchMemberPetList().then(() => {
              this.FormMixSubmitData.petId = getDefaultPetId('') || DEFAULT_SUBMIT_DATA.petId
              this.FormMixSubmitData.isUserMemberPet = true
            })
          })
        }

        this.FormMixSubmitData.isUserMemberPet = false

        this.$globalDialog('DialogLogin', {
          callbackLogin: () => {
            loggedInFn()
          },
        })
      }
    },
    async tryToFetchMemberPetList() {
      await this.$store
        .dispatch('auth/fetchMemberPetList', {
          useCached: true,
        })
        .then(() => {
          return true
        })
    },
    onChangeCategory(category) {
      const setFormMixSubmitDataSizeAlias = () => {
        const sizeOptions = this.sizeOptions(category)

        this.FormMixSubmitData.sizeAlias = sizeOptions[0]?.value || ''
      }

      setFormMixSubmitDataSizeAlias()
    },
    openDialogPet() {
      this.$globalDialog('DialogPet', {
        type: 'add',
        callbackNewPet: (submitData) => {
          this.FormMixSubmitData.petId = submitData.id
        },
      })
    },
    onChangePage: _debounce(function (page) {
      this.datePickerYear = this.datePickerYear === page.year ? this.datePickerYear : page.year
      this.datePickerMonth = this.datePickerMonth === page.month ? this.datePickerMonth : page.month
    }, 500),
    watchReservationCalendar: _debounce(function (page) {
      this.tryToFetchReservationCalendar()
    }, 500),
    watchCurrentReservationCalendarDate: _debounce(function (page) {
      // this.tryToFetchCurrentReservationCalendarDate()
    }, 500),
    currentDatePage() {
      if (!this.datePickerYear || !this.datePickerMonth) return
      // this.$refs.date.move(`${this.datePickerYear}-${this.datePickerMonth}`)
      this.getCurrentReservationCalendar()
    },
    getCurrentReservationCalendar() {
      const date = new Date(this.datePickerYear, this.datePickerMonth - 1)
      const isThisCurrentYear = isThisYear(date)
      const isThisCurrentMonth = isThisMonth(date)
      if (isThisCurrentYear && isThisCurrentMonth) {
        this.startDate = formatDate(new Date(), 'yyyy-MM-dd')
        this.endDate = formatDate(lastDayOfMonth(new Date()), 'yyyy-MM-dd')
      } else {
        this.startDate = formatDate(date, 'yyyy-MM-dd')
        this.endDate = formatDate(lastDayOfMonth(date), 'yyyy-MM-dd')
      }
    },
    tryToFetchReservationCalendar() {
      if (!this.startDate && !this.endDate) {
        return
      }
      const submitData = {
        startDate: this.startDate,
        endDate: this.endDate,
        storeAlias: this.FormMixSubmitData.storeAlias,
        sizeAlias: this.FormMixSubmitData.sizeAlias,
        types: [this.serviceType === 'reservation' ? 'cosmetic' : this.serviceType],
      }
      // this.$nextTick(() => {
      this.$store
        .dispatch('merchant/fetchReservationCalendar', {
          ...submitData,
        })
        .then(({ items }) => {
          const currentDisabledDate = Object.keys(items).length
            ? Object.keys(items).filter((item) => {
                return !items[item].isOpen
              })
            : []
          this.currentDisabledDate = currentDisabledDate.length
            ? currentDisabledDate.map((item) => {
                return parseISO(item)
              })
            : []
          this.formatDisabledDateTime = currentDisabledDate.length
            ? currentDisabledDate.map((item) => {
                return parseISO(item).getTime()
              })
            : []
        })
      // })
      // this.tryToFetchReservationCalendar(submitDate)
    },
    tryToFetchCurrentReservationCalendarDate() {
      if (!this.FormMixSubmitData.date) {
        return
      }
      const submitData = {
        startDate: this.FormMixSubmitData.date,
        endDate: this.FormMixSubmitData.date,
        storeAlias: this.FormMixSubmitData.storeAlias,
        sizeAlias: this.FormMixSubmitData.sizeAlias,
        types: [this.serviceType === 'reservation' ? 'cosmetic' : this.serviceType],
      }
      // this.$nextTick(() => {
      this.$store
        .dispatch('merchant/fetchReservationCalendar', {
          ...submitData,
        })
        .then(({ items }) => {
          const currentDisabledDate = Object.keys(items).length
            ? Object.keys(items).filter((item) => {
                return !items[item].isOpen
              })
            : []
          this.isCurrentDiabeldDate = !!currentDisabledDate.length
        })
      // })
      // this.tryToFetchReservationCalendar(submitDate)
    },
    onFocus() {
      const targetYear = document.querySelectorAll('.el-date-picker__header-label')[0].textContent.split(' ')[0]
      const targetMonth = document.querySelectorAll('.el-date-picker__header-label')[1].textContent.split(' ')[0]
      const data = {
        month: targetMonth,
        year: targetYear,
      }
      this.onChangePage(data)
    },
    goToLogin() {
      if (liff.isInClient() && this.isLiffInit) {
        lineGetProfileAndLogin({
          liffId: this.currentLiffId,
          callBack: () => {
            messageSuccess({
              title: '驗證成功',
              content: '您已成功登入。',
            })
          },
        })
      } else {
        this.$globalDialog('DialogLogin', {})
      }
    },
  },
}
</script>

<!-- section style -->
<style lang="scss" module>
.formReservationJtails {
  margin-bottom: -22px;

  :global {
    .formReservationJtails {
      &__submit {
        margin-top: 25px;
        margin-bottom: 22px;
      }
    }
  }
}
</style>
